<script lang="ts">
</script>

<main>
  <p>Made with Svelte</p>
  <p>&copy; 2022 Fatih Nararya R. I.</p>
</main>

<style>
  main {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 0.25em;
    /* height: var(--footer-height); */
    justify-content: center;
    padding: 0 0 0.25em 0;
    margin: 0;

    /* border: solid 1px black; */
  }
  p {
    text-align: center;
  }
</style>
